var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargePlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2822_26397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.92893 16.3787C3.11929 16.9216 2 17.6716 2 18.5C2 20.1569 6.47715 21.5 12 21.5C17.5229 21.5 22 20.1569 22 18.5C22 17.6716 20.8807 16.9216 19.0711 16.3787",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5C12 17.5 18.5 13.252 18.5 8.3409C18.5 4.83892 15.5898 2 12 2C8.41015 2 5.5 4.83892 5.5 8.3409C5.5 13.252 12 17.5 12 17.5Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11C13.3807 11 14.5 9.8807 14.5 8.5C14.5 7.1193 13.3807 6 12 6C10.6193 6 9.5 7.1193 9.5 8.5C9.5 9.8807 10.6193 11 12 11Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2822_26397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargePlot);
export default __webpack_public_path__ + "static/media/large_plot.c901e53573932c3fff81d37af1146991.svg";
export { ForwardRef as ReactComponent };